module.exports = __webpack_public_path__ + "static/media/instal-drawer-mf-ikon@3x.acc8ce0a.png";